import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
import intlShape from '@/shared/utils/intlShape';
import messages from '../documentMessages';

export default class SetIsPublicOnPortalModal extends Component {
  state = {
    setIsPublicOnPortal: false,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { setIsPublicOnPortal } = this.state;
    const { onSave } = this.props;

    return onSave({ setIsPublicOnPortal });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { setIsPublicOnPortal } = this.state;
    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.EnableOrDisableIsPublicOnPortal)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.IsPublicOnPortal} />
              </label>
              <div className="col-md-9" style={{ marginTop: '7px' }}>
                <Checkbox
                  onClick={() => this.setState({ setIsPublicOnPortal: !setIsPublicOnPortal })}
                  value={setIsPublicOnPortal}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
